var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11.5,
    stroke: "#F2F2F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 4C9.376 4 4 9.376 4 16C4 22.624 9.376 28 16 28C22.624 28 28 22.624 28 16C28 9.376 22.624 4 16 4ZM13.6 22L7.6 16L9.292 14.308L13.6 18.604L22.708 9.496L24.4 11.2L13.6 22Z",
    fill: "#2F54EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckCircle);
export default __webpack_public_path__ + "static/media/icon_check_circle.9a9e60ae16fade2192840389d4b4151f.svg";
export { ForwardRef as ReactComponent };